import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    TextField,
    TablePagination,
    MenuItem,
    Grid
} from "@mui/material";

import {
    collection,
    query,
    orderBy,
    onSnapshot
} from "firebase/firestore";

import { db } from "../../firebase";

function Throughreport() {

    const [trips, setTrips] = useState([]);
    const [throughs, setThroughs] = useState([]);

    const [search, setSearch] = useState("");
    const [selectedThrough, setSelectedThrough] = useState("");

    const [fromDate, setFromDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [toDate, setToDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    // Load Through Details
    useEffect(() => {

        const unsub = onSnapshot(
            collection(db, "throughdetails"),
            (snap) => {
                setThroughs(
                    snap.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }))
                );
            }
        );

        return () => unsub();

    }, []);

    // Load Trips
    useEffect(() => {

        const q = query(
            collection(db, "trips"),
            orderBy("grossDate", "desc")
        );

        const unsub = onSnapshot(q, (snapshot) => {

            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setTrips(data);

        });

        return () => unsub();

    }, []);

    const filteredTrips = trips.filter((trip) => {

        const tripDate = trip.grossDate?.toDate
            ? trip.grossDate.toDate()
            : null;

        const from = new Date(fromDate);
        from.setHours(0, 0, 0, 0);

        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);

        const dateMatch =
            !tripDate ||
            (tripDate >= from && tripDate <= to);

        const throughMatch =
            !selectedThrough ||
            trip.throughId === selectedThrough;

        const searchMatch =
            JSON.stringify(trip)
                .toLowerCase()
                .includes(search.toLowerCase());

        return dateMatch && throughMatch && searchMatch;
    });

    const totalAmount = filteredTrips.reduce(
        (sum, row) => sum + Number(row.totalAmount || 0),
        0
    );

    const totalNetWeight = filteredTrips.reduce(
        (sum, row) => sum + Number(row.netWeight || 0),
        0
    );

    return (
        <Box
            sx={{
                p: 1,
                bgcolor: "#f5f5f5",
                minHeight: "100vh",
                "& .MuiTableCell-root": {
                    fontSize: 12,
                    padding: "4px"
                }
            }}
        >
            <Paper sx={{ p: 2 }}>

                <Typography
                    variant="h6"
                    fontWeight="bold"
                    mb={2}
                >
                    Through Report
                </Typography>

                <Grid container spacing={1} mb={2}>

                    <Grid item xs={12} md={2}>
                        <TextField
                            label="From Date"
                            type="date"
                            size="small"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={fromDate}
                            onChange={(e) =>
                                setFromDate(e.target.value)
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <TextField
                            label="To Date"
                            type="date"
                            size="small"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={toDate}
                            onChange={(e) =>
                                setToDate(e.target.value)
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            select
                            fullWidth
                            size="small"
                            label="Through"
                            value={selectedThrough}
                            onChange={(e) =>
                                setSelectedThrough(
                                    e.target.value
                                )
                            }
                        >
                            <MenuItem value="">
                                All Through
                            </MenuItem>

                            {throughs.map((item) => (
                                <MenuItem
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Search"
                            size="small"
                            fullWidth
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                        />
                    </Grid>

                </Grid>

                <Box
                    display="flex"
                    gap={4}
                    mb={2}
                    flexWrap="wrap"
                >
                    <Typography fontWeight="bold">
                        Trips : {filteredTrips.length}
                    </Typography>

                    <Typography
                        fontWeight="bold"
                        color="success.main"
                    >
                        Amount : ₹
                        {Math.round(totalAmount).toLocaleString()}
                    </Typography>

                    <Typography
                        fontWeight="bold"
                        color="primary"
                    >
                        Net Weight :{" "}
                        {Math.round(totalNetWeight)}
                    </Typography>
                </Box>

                <TableContainer>

                    <Table size="small">

                        <TableHead>
                            <TableRow
                                sx={{
                                    bgcolor: "#eeeeee"
                                }}
                            >
                                <TableCell>SR</TableCell>
                                <TableCell>Challan</TableCell>
                                <TableCell>Ticket</TableCell>
                                <TableCell>Through</TableCell>
                                <TableCell>Customer</TableCell>
                                <TableCell>Vehicle</TableCell>
                                <TableCell>Net Weight</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Date</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>

                            {filteredTrips
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage +
                                        rowsPerPage
                                )
                                .map((row, index) => (

                                    <TableRow key={row.id} hover>

                                        <TableCell>
                                            {page *
                                                rowsPerPage +
                                                index +
                                                1}
                                        </TableCell>

                                        <TableCell>
                                            {row.challan}
                                        </TableCell>

                                        <TableCell>
                                            {row.ticketNo}
                                        </TableCell>

                                        <TableCell>
                                            {row.throughName}
                                        </TableCell>

                                        <TableCell>
                                            {row.customerName}
                                        </TableCell>

                                        <TableCell>
                                            {row.vehicleNo}
                                        </TableCell>

                                        <TableCell>
                                            {row.netWeight}
                                        </TableCell>

                                        <TableCell>
                                            ₹
                                            {Math.round(
                                                row.totalAmount || 0
                                            ).toLocaleString()}
                                        </TableCell>

                                        <TableCell>
                                            {row.grossDate?.toDate
                                                ? row.grossDate
                                                      .toDate()
                                                      .toLocaleString()
                                                : "-"}
                                        </TableCell>

                                    </TableRow>
                                ))}

                        </TableBody>

                    </Table>

                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredTrips.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) =>
                        setPage(newPage)
                    }
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(
                            parseInt(e.target.value, 10)
                        );
                        setPage(0);
                    }}
                />

            </Paper>
        </Box>
    );
}

export default Throughreport;